import { SetStateAction, useRef } from "react";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";

interface PhoneInputComponentProps {
  phoneData: {
    phoneNumber: string;
    phoneExt: string;
    phoneValue: string;
  };
  setPhoneData: React.Dispatch<
    React.SetStateAction<{
      phoneNumber: string;
      phoneExt: string | any;
      phoneValue: string;
    }>
  >;
  country?: string;
  form: any;
  countriesList: any;
  fieldName: any;
  isDisabled? : boolean;
}

export const PhoneInputComponent = ({
  form,
  phoneData,
  setPhoneData,
  country,
  countriesList,
  fieldName,
  isDisabled = false
}: PhoneInputComponentProps) => {
  const elementId = `pdfForm_${fieldName}`;
  const phoneInputRef = useRef<HTMLDivElement | null>(null);

  const handleChange = (
    value: any,
    country: { dialCode: SetStateAction<string> }
  ) => {
    const rawNumber = value.startsWith(country.dialCode)
      ? value.slice(`${country.dialCode}`.length).trim()
      : value;
    setPhoneData({
      ...phoneData,
      phoneNumber: rawNumber,
      phoneExt: country?.dialCode,
      phoneValue: value,
    });
    if (rawNumber && rawNumber !== "") {
      form.setFieldsValue({
        [`${fieldName}`]: value,
      });
    } else {
      form.setFieldsValue({
        [`${fieldName}`]: "",
      });
    }
  };

  return (
    <div ref={phoneInputRef} id={elementId}>
    <PhoneInput
      country={country || "us"}
      enableSearch
      disableSearchIcon
      value={phoneData?.phoneValue}
      onChange={handleChange}
      onlyCountries={countriesList}
      disabled={isDisabled}
    />
    </div>
  );
};

export default PhoneInputComponent;
